exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.recipient-country-select .multiselect__option {\r\n    padding : 0 !important;\n}\n.recipient-country-select .multiselect__option .lgt-option {\r\n    padding : 12px;\n}\n.recipient-country-select .multiselect__option .lgt-option.disabled {\r\n    color: #b5b3b3;\r\n    background-color: #eaeaea;\r\n    cursor: not-allowed;\n}\r\n\r\n\r\n", ""]);

// exports
